
export enum PermissionMutationType{
    SET_ROUTES = 'SET_ROUTES'
}
